import React from "react";
import { useParams } from "react-router-dom";
import { isValidLocale } from "src/locales";
import { getLazyComponent } from "src/router";
import LandingPage from "..";

const NotFound = getLazyComponent(
  () => import(/* webpackChunkName: "NotFoundPage" */ "../[...404]")
);

export default function Redirect() {
  const { locale } = useParams<{ locale: string }>();

  /**
   * Because this page captures all unmatched root paths, we need to see if the
   * passed variable is truly the intended parameter (a valid locale).
   * If it's not, render 404 page.
   */
  if (!isValidLocale(locale)) {
    return <NotFound />;
  }

  return <LandingPage />;
}
